export default "__VITE_ASSET__b4166829__"